import { render, staticRenderFns } from "./RegPage.vue?vue&type=template&id=a0e285e4&scoped=true&"
import script from "./RegPage.vue?vue&type=script&lang=js&"
export * from "./RegPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e285e4",
  null
  
)

export default component.exports